





































import {
  computed,
  defineComponent,
  onMounted,
  watch
} from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  props: {
    message: {
      default:
        "Try again or if this this problem keeps occuring contact support"
    },
    title: {
      default: "Something went wrong"
    },
    error: {
      default: "An unknown error occured"
    }
  },
  setup(_props, ctx) {
    const { store } = useVuex();
    const expert = computed(() => store.state.Settings.mode === "expert");
    const stopLoading = store.commit.Loading.stopLoading;

    onMounted(() => {
      stopLoading();
    });

    const back = async () => {
      await ctx.root.$router.replace("/force-rerender");
      ctx.root.$router.go(-1);
    };

    const props = computed(() => {
      const componentProps = {
        message: _props.message,
        title: _props.title,
        error: _props.error
      };
      const props = ctx.root.$route.meta.props || componentProps;
      return props;
    });

    const errorParsed = computed(() => {
      const { error } = _props;
      try {
        return error === "string" ? error : JSON.stringify(error, null, 2);
      } catch {
        return "";
      }
    });

    const changes = computed(() => {
      return [
        _props?.message,
        _props?.title,
        _props?.error,
        ctx.root.$route.meta.props
      ];
    });

    watch(() => changes.value, stopLoading, {
      immediate: true,
      deep: true
    });

    return {
      stopLoading,
      expert,
      back,
      props,
      errorParsed
    };
  }
});
